import { type AgGridReact } from "@jsq/ds/core";

export const CLIENTS_TABLE_PAGE_SIZE = 50;
export const getClientRowId = (params: {
  data?: { arenaId: string; arenaName: string };
}): string => {
  if (!params.data) return "";
  return params.data.arenaId;
};

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  suppressCellFocus: true,
  suppressRowHoverHighlight: false,
  domLayout: "normal",
  rowHeight: 62,
  onSortChanged: (event) => {
    event.api.paginationGoToFirstPage();
    event.api.refreshServerSide({ purge: true });
  },
  defaultColDef: {
    resizable: true,
    menuTabs: [],
    sortable: true,
    suppressHeaderMenuButton: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: 100,
  },
  suppressRowClickSelection: true,
  pagination: true,
  paginationPageSize: CLIENTS_TABLE_PAGE_SIZE,
  paginationPageSizeSelector: [25, 50, 100],
  rowModelType: "serverSide",
  cacheBlockSize: CLIENTS_TABLE_PAGE_SIZE,
  maxBlocksInCache: 10,
  getRowId: getClientRowId,
  suppressHorizontalScroll: false,
  enableBrowserTooltips: true,
  suppressContextMenu: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  statusBar: {
    statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
  },
};
